import { gx } from "@/components/gtax/base";
import { Area, AreaChart, Bar, BarChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { Link } from "react-router-dom";
import { REPORT, usd } from "./data";

export const tip = { background: "#1E1A14", border: "1px solid rgba(201,162,74,.3)", color: "#EDE6D6", fontSize: 13 };

export const CurveChart = ({ h = 360 }) => (
  <div className="gx-card p-6" style={{ height: h }} data-testid="gtax-growth-chart">
    <ResponsiveContainer>
      <AreaChart data={REPORT.curve}>
        <defs>
          <linearGradient id="gxg" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#C9A24A" stopOpacity={0.5} />
            <stop offset="100%" stopColor="#C9A24A" stopOpacity={0} />
          </linearGradient>
        </defs>
        <XAxis dataKey="m" stroke="#6B5F4B" tickLine={false} axisLine={false} fontSize={13} />
        <YAxis stroke="#6B5F4B" tickLine={false} axisLine={false} fontSize={13} width={60} tickFormatter={(v) => `$${Math.round(v / 1000)}k`} />
        <Tooltip contentStyle={tip} formatter={(v) => usd(v)} />
        <Area type="monotone" dataKey="v" name="Cumulative net profit" stroke="#8F6B22" strokeWidth={2.5} fill="url(#gxg)" />
      </AreaChart>
    </ResponsiveContainer>
  </div>
);

export const MonthlyChart = ({ h = 360 }) => (
  <div className="gx-card p-6" style={{ height: h }} data-testid="gtax-monthly-chart">
    <ResponsiveContainer>
      <BarChart data={REPORT.months}>
        <XAxis dataKey="m" stroke="#6B5F4B" tickLine={false} axisLine={false} fontSize={13} />
        <Tooltip contentStyle={tip} cursor={{ fill: "rgba(201,162,74,.08)" }} formatter={(v) => usd(v)} />
        <Bar dataKey="v" name="Net profit" fill="#B8892B" radius={[2, 2, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  </div>
);

export const GtaxPerformance = () => (
  <section id="performance" className="py-28 gx-line" data-testid="gtax-performance">
    <div className="gx-wrap">
      <p className="gx-eyebrow">Track record</p>
      <div className="mt-6 flex flex-wrap items-end justify-between gap-6">
        <h2 className="gx-serif text-4xl md:text-5xl max-w-2xl">Realised results, reported from the trading account.</h2>
        <div className="text-right" data-testid="gtax-growth-total">
          <div className="text-xs text-[color:var(--mute)] tracking-widest uppercase">Net realised profit · {REPORT.period}</div>
          <div className="gx-serif text-5xl gx-gold">{usd(REPORT.net)}</div>
        </div>
      </div>
      <div className="mt-14 grid lg:grid-cols-5 gap-6">
        <div className="lg:col-span-3"><CurveChart /></div>
        <div className="lg:col-span-2"><MonthlyChart /></div>
      </div>
      <div className="mt-6 flex flex-wrap justify-between gap-4 text-xs text-[color:var(--mute)]">
        <span>Source: MT5 account history, XAUUSD, gross results before member profit-share. A short track record of under seven months. Past performance doesn't guarantee future results.</span>
        <Link to={gx("/report")} className="underline hover:text-[color:var(--gold2)]" data-testid="gtax-perf-report-link">Open the full performance report</Link>
      </div>
    </div>
  </section>
);
